import React from "react";

/**
 * ResearchSkeleton - placeholder shown while a model's analysis is still
 * being requested and no text has streamed in yet. Purely decorative.
 *
 * @param {string} modelName - Model the skeleton stands in for
 */
export default function ResearchSkeleton({ modelName = "" }) {
  return (
    <div className="rs-skeleton-card" aria-hidden="true">
      <div className="rs-skeleton-block">
        <div className="ds-skeleton" style={{ height: 13, width: "42%", marginBottom: 14 }} />
        <div className="ds-skeleton ds-skeleton-text" style={{ width: "100%" }} />
        <div className="ds-skeleton ds-skeleton-text" style={{ width: "94%" }} />
        <div className="ds-skeleton ds-skeleton-text" style={{ width: "78%" }} />
      </div>

      <div className="rs-skeleton-block">
        <div className="ds-skeleton" style={{ height: 13, width: "36%", marginBottom: 14 }} />
        <div className="ds-skeleton ds-skeleton-text" style={{ width: "100%" }} />
        <div className="ds-skeleton ds-skeleton-text" style={{ width: "88%" }} />
      </div>

      <span className="ds-sr-only">Preparing {modelName} analysis</span>
    </div>
  );
}
